module.exports = __webpack_public_path__ + "img/hopways-02.7d9ee8e5.jpeg";